export default {
  title: 'Rapport MRR',
  fields: {
    name: 'Nom',
    area: 'Zone',
    mrr: 'MRR (net)',
  },
  buttons: {
    download_report: 'Télécharger le rapport',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données, veuillez rafraîchir la page',
  },
};
